import { useFormikContext } from 'formik';
import { Link1, MouseCircle } from 'iconsax-react';
import { Switch } from '@src/design-system/switch';
import { Textfield } from '@src/shared/fields/text-field';
import type { TAnnouncementFormValues } from '../schema';
import { AnnouncementSectionTitle } from './announcement-section-title';

export function AnnouncementCtaSection() {
  const { values, setFieldValue } = useFormikContext<TAnnouncementFormValues>();

  return (
    <section className='flex w-full flex-col gap-4 rounded-xl border border-primary-100 bg-white p-6'>
      <AnnouncementSectionTitle title='3. CTA Link' />

      <div className='flex items-center gap-2'>
        <Switch
          checked={values.showCta}
          onCheckedChange={(checked) => setFieldValue('showCta', checked)}
          aria-label='Show Button'
        />
        <span className='text-sm font-medium text-gray-900'>Show Button</span>
      </div>

      {values.showCta ? (
        <div className='flex flex-col gap-4'>
          <Textfield
            name='cta_label'
            label='Button Name'
            placeholder='Enter button name'
            prefixIcon={
              <MouseCircle
                size={20}
                variant='Outline'
              />
            }
          />
          <Textfield
            name='cta_link'
            label='Redirection Link'
            placeholder='Enter redirection link'
            prefixIcon={
              <Link1
                size={20}
                variant='Outline'
              />
            }
          />
        </div>
      ) : null}
    </section>
  );
}
